import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useRef, useState } from 'react';
import AHMIS, { API_URL } from '../../../api/api';
import AddAlertMessage from '../../../components/alert/Alert';
import PatientCountCell from '../../../components/patient-count-cell/PatientCountCell';
import { ERROR, REPORT_NOT_DRAWN, SOMETHING_WENT_WRONG, SUCCESS } from '../../../utils/constants';
import MessageBlock from '../../admin/components/message-block/MessageBlock';
import ReportHeader from '../component/report-header/ReportHeader';

const NcdReport = () => {
  const [tableData, setTableData] = useState();
  const printComponentRef = useRef();

  const getReportData = (dateFrom, dateTo) => {
    const url = `${API_URL.ncdReport}?fromDate=${dateFrom}&toDate=${dateTo}`;
    AHMIS.get(url)
      .then(response => {
        const jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setTableData(jsondata.data);
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: `${SOMETHING_WENT_WRONG}: ${error.message}` });
      });
  };

  return (
    <>
      <ReportHeader title="नसर्ने रोगको  प्रतिबेदन"
        getReportData={getReportData}
        reportData={Boolean(tableData)}
        printComponentRef={printComponentRef}
      />
      {tableData ? (
        <Box ref={printComponentRef}>
          <TableContainer classes={{ root: "fixed-head-table-container" }}  >
            <Typography variant="body1" className="report-heading">नसर्ने रोगको  प्रतिबेदन </Typography>
            <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="NCD-Sewa-Report">
              <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
                <TableRow>
                  <TableCell rowSpan={2}>सेवाको प्रकार अनुसार सेवा लिएको विवरण</TableCell>
                  <TableCell colSpan={3}>मनोसामाजिक सेवा</TableCell>
                  <TableCell colSpan={3}>परामर्श सेवा</TableCell>
                  <TableCell colSpan={3}>औषधी</TableCell>
                  <TableCell colSpan={3}>अन्य</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>महिला</TableCell>
                  <TableCell>पुरूष</TableCell>
                  <TableCell>अन्य</TableCell>
                  <TableCell>महिला</TableCell>
                  <TableCell>पुरूष</TableCell>
                  <TableCell>अन्य</TableCell>
                  <TableCell>महिला</TableCell>
                  <TableCell>पुरूष</TableCell>
                  <TableCell>अन्य</TableCell>
                  <TableCell>महिला</TableCell>
                  <TableCell>पुरूष</TableCell>
                  <TableCell>अन्य</TableCell>
                </TableRow>
              </TableHead>
              <TableBody classes={{ root: "align-center" }}>
                <TableRow>
                  <TableCell>नसर्ने रोगी</TableCell>
                  <PatientCountCell data={tableData?.report?.NON_COMMUNICABLE_DISEASE?.mentalConsultation?.FEMALE} />
                  <PatientCountCell data={tableData?.report?.NON_COMMUNICABLE_DISEASE?.mentalConsultation?.MALE} />
                  <PatientCountCell data={tableData?.report?.NON_COMMUNICABLE_DISEASE?.mentalConsultation?.OTHER} />
                  <PatientCountCell data={tableData?.report?.NON_COMMUNICABLE_DISEASE?.paramarsa?.FEMALE} />
                  <PatientCountCell data={tableData?.report?.NON_COMMUNICABLE_DISEASE?.paramarsa?.MALE} />
                  <PatientCountCell data={tableData?.report?.NON_COMMUNICABLE_DISEASE?.paramarsa?.OTHER} />
                  <PatientCountCell data={tableData?.report?.NON_COMMUNICABLE_DISEASE?.medicine?.FEMALE} />
                  <PatientCountCell data={tableData?.report?.NON_COMMUNICABLE_DISEASE?.medicine?.MALE} />
                  <PatientCountCell data={tableData?.report?.NON_COMMUNICABLE_DISEASE?.medicine?.OTHER} />
                  <PatientCountCell data={tableData?.report?.NON_COMMUNICABLE_DISEASE?.others?.FEMALE} />
                  <PatientCountCell data={tableData?.report?.NON_COMMUNICABLE_DISEASE?.others?.MALE} />
                  <PatientCountCell data={tableData?.report?.NON_COMMUNICABLE_DISEASE?.others?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>मानसिक रोगी</TableCell>
                  <PatientCountCell data={tableData?.report?.MENTAL_HEALTH?.mentalConsultation?.FEMALE} />
                  <PatientCountCell data={tableData?.report?.MENTAL_HEALTH?.mentalConsultation?.MALE} />
                  <PatientCountCell data={tableData?.report?.MENTAL_HEALTH?.mentalConsultation?.OTHER} />
                  <PatientCountCell data={tableData?.report?.MENTAL_HEALTH?.paramarsa?.FEMALE} />
                  <PatientCountCell data={tableData?.report?.MENTAL_HEALTH?.paramarsa?.MALE} />
                  <PatientCountCell data={tableData?.report?.MENTAL_HEALTH?.paramarsa?.OTHER} />
                  <PatientCountCell data={tableData?.report?.MENTAL_HEALTH?.medicine?.FEMALE} />
                  <PatientCountCell data={tableData?.report?.MENTAL_HEALTH?.medicine?.MALE} />
                  <PatientCountCell data={tableData?.report?.MENTAL_HEALTH?.medicine?.OTHER} />
                  <PatientCountCell data={tableData?.report?.MENTAL_HEALTH?.others?.FEMALE} />
                  <PatientCountCell data={tableData?.report?.MENTAL_HEALTH?.others?.MALE} />
                  <PatientCountCell data={tableData?.report?.MENTAL_HEALTH?.others?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>चोट लागेको</TableCell>
                  <PatientCountCell data={tableData?.report?.INJURY?.mentalConsultation?.FEMALE} />
                  <PatientCountCell data={tableData?.report?.INJURY?.mentalConsultation?.MALE} />
                  <PatientCountCell data={tableData?.report?.INJURY?.mentalConsultation?.OTHER} />
                  <PatientCountCell data={tableData?.report?.INJURY?.paramarsa?.FEMALE} />
                  <PatientCountCell data={tableData?.report?.INJURY?.paramarsa?.MALE} />
                  <PatientCountCell data={tableData?.report?.INJURY?.paramarsa?.OTHER} />
                  <PatientCountCell data={tableData?.report?.INJURY?.medicine?.FEMALE} />
                  <PatientCountCell data={tableData?.report?.INJURY?.medicine?.MALE} />
                  <PatientCountCell data={tableData?.report?.INJURY?.medicine?.OTHER} />
                  <PatientCountCell data={tableData?.report?.INJURY?.others?.FEMALE} />
                  <PatientCountCell data={tableData?.report?.INJURY?.others?.MALE} />
                  <PatientCountCell data={tableData?.report?.INJURY?.others?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>असक्षमता भएको</TableCell>
                  <PatientCountCell data={tableData?.report?.DISABILITY?.mentalConsultation?.FEMALE} />
                  <PatientCountCell data={tableData?.report?.DISABILITY?.mentalConsultation?.MALE} />
                  <PatientCountCell data={tableData?.report?.DISABILITY?.mentalConsultation?.OTHER} />
                  <PatientCountCell data={tableData?.report?.DISABILITY?.paramarsa?.FEMALE} />
                  <PatientCountCell data={tableData?.report?.DISABILITY?.paramarsa?.MALE} />
                  <PatientCountCell data={tableData?.report?.DISABILITY?.paramarsa?.OTHER} />
                  <PatientCountCell data={tableData?.report?.DISABILITY?.medicine?.FEMALE} />
                  <PatientCountCell data={tableData?.report?.DISABILITY?.medicine?.MALE} />
                  <PatientCountCell data={tableData?.report?.DISABILITY?.medicine?.OTHER} />
                  <PatientCountCell data={tableData?.report?.DISABILITY?.others?.FEMALE} />
                  <PatientCountCell data={tableData?.report?.DISABILITY?.others?.MALE} />
                  <PatientCountCell data={tableData?.report?.DISABILITY?.others?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>जम्मा</TableCell>
                  <PatientCountCell data={tableData?.totalMap?.mentalConsultation?.FEMALE} />
                  <PatientCountCell data={tableData?.totalMap?.mentalConsultation?.MALE} />
                  <PatientCountCell data={tableData?.totalMap?.mentalConsultation?.OTHER} />
                  <PatientCountCell data={tableData?.totalMap?.paramarsa?.FEMALE} />
                  <PatientCountCell data={tableData?.totalMap?.paramarsa?.MALE} />
                  <PatientCountCell data={tableData?.totalMap?.paramarsa?.OTHER} />
                  <PatientCountCell data={tableData?.totalMap?.medicine?.FEMALE} />
                  <PatientCountCell data={tableData?.totalMap?.medicine?.MALE} />
                  <PatientCountCell data={tableData?.totalMap?.medicine?.OTHER} />
                  <PatientCountCell data={tableData?.totalMap?.others?.FEMALE} />
                  <PatientCountCell data={tableData?.totalMap?.others?.MALE} />
                  <PatientCountCell data={tableData?.totalMap?.others?.OTHER} />
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ) : (
        <MessageBlock text={REPORT_NOT_DRAWN} />
      )}
    </>
  )
}

export default NcdReport
